import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpContextToken,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
 
import { Router } from '@angular/router';
import { LoaderService } from '../services/loader/loader.service';

export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export const loaderInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loaderService = inject(LoaderService);
  const router = inject(Router);

  if (request.context.get(SKIP_GLOBAL_LOADER)) {
    return next(request);
  }
  
  // Get current route
  const currentUrl = router.url;
  
  // Define routes where loader should be hidden
  const excludedRoutes = [
    '/',
    '/home',
    '/news/allNews',
    '/news/news-details',
    '/login',
    
     
    '/forgot-password',
    '/reset-password',
    '/verify-email',
    '/verify-phone',
    '/verify-code',
  ];
  
  // Check if current route should show loader
  const shouldShowLoader = !excludedRoutes.some(route => 
    currentUrl === route || currentUrl.startsWith(route + '/')
  );
  
  if (shouldShowLoader) {
    loaderService.show(); // Show the loader only for non-excluded routes
  }

  return next(request).pipe(
    finalize(() => {
      if (shouldShowLoader) {
        loaderService.hide(); // Hide the loader after completion
      }
    })
  );
};
